import type { EntityConfig } from '../types'

export const cardProgramEntity: EntityConfig = {
  id: 'card-program',
  displayName: 'Card Program',
  status: {
    filters: [
      { value: 'all', label: 'All' },
      { value: 'active', label: 'Active' },
      { value: 'inactive', label: 'Inactive' },
      { value: 'draft', label: 'Draft' },
      { value: 'pending_approval', label: 'Pending Approval' },
      { value: 'suspended', label: 'Suspended' },
    ],
    options: [
      { value: 'active', label: 'Active', color: 'success' },
      { value: 'inactive', label: 'Inactive', color: 'neutral' },
      { value: 'draft', label: 'Draft', color: 'warning' },
      { value: 'pending_approval', label: 'Pending Approval', color: 'info' },
      { value: 'suspended', label: 'Suspended', color: 'error' },
    ],
    mappings: {
      all: [],
      active: ['active'],
      inactive: ['inactive'],
      draft: ['draft'],
      pending_approval: ['pending_approval'],
      suspended: ['suspended'],
    }
  },
  queryFields: {
    status: { type: 'status_array', urlKey: 'status' },
    dateRange: { type: 'date_range', urlKey: 'date' },
    type: { type: 'string_array', urlKey: 'type' },
    network: { type: 'string_array', urlKey: 'network' },
    search: { type: 'search', urlKey: '$s' }
  },
  uiFilterFields: [
    'search',
    'status',
    'dateRange',
  ]
}
